import Field from 'libs/field'
import { useFormik } from 'formik'
import Button from 'libs/button/Button'
import { selectSelectedItem } from 'store/redux/navSlice'
import {
  EmployeeDepartmentFilters,
 
} from '../employee-departments-endpoints/employeedepartmentTypes'

import { useSelector } from 'react-redux'
import { useGetEmployeeDepartmentQuery } from '../employee-departments-endpoints/employeesdepartment.endpoints'
import { useMemo } from 'react'

interface Props {
  closePanel: () => void
  setFilters: any
  filters: EmployeeDepartmentFilters
}
const defaultFilters = {
  page_no: 1,
  page_size: 1000,
  sortBy: 'created_on',
  sortDir: 'DESC',
}

const FilterPanel = ({ closePanel, filters, setFilters }: Props) => {
  const plant = useSelector(selectSelectedItem)
  const initialValues = {
    roles: filters?.roles?.length === 0 ? [] : filters?.roles,
    department: filters?.department?.length == 0 ? [] : filters?.department,
  }

  const filterFormik = useFormik({
    initialValues: initialValues,

    onSubmit: (values) => {
      setFilters((prevFilters: EmployeeDepartmentFilters) => ({
        ...prevFilters,
        department: values?.department,
        roles: values?.roles,
      }))
    },
  })

  const { data: employeeDepartments } = useGetEmployeeDepartmentQuery(
    {
      plant_id: plant?.id,
      filters: defaultFilters,
    },
    {
      skip: !plant?.id,
    },
  )


  const handleReset = () => {
    setFilters({
      page_no: 1,
      page_size: 10,
      searchText: '',
      sortBy: 'created_on',
      sortDir: 'DESC',
    })
    closePanel()
  }

const departmentsOptions = useMemo(
  () =>
    employeeDepartments?.data?.map((item: any) => ({
      label: item?.name,
      value: item?.name,
    })) || [],
  [employeeDepartments],
)

const designationsOptions = useMemo(
  () =>
    employeeDepartments?.data
      ?.filter((item: any) => filterFormik?.values?.department?.includes(item?.name))
      .flatMap(
        (item: any) =>
          item?.designations?.map((designation: any) => ({
            label: designation?.name,
            value: designation?._id,
          })) || [],
      ) || [],
  [employeeDepartments, filterFormik?.values.department],
)

  return (
    <>
      <div className="flex flex-col gap-3">
        <Field
          type="multiselect"
          label="Department"
          placeholder="Show All"
          options={departmentsOptions}
          formik={filterFormik}
          name="department"
        />
        <Field
          type="multiselect"
          label="Designations"
          placeholder="Show All"
          disabled={filterFormik?.values?.department?.length === 0}
          options={designationsOptions}
          formik={filterFormik}
          name="roles"
        />
      </div>
      <div className="flex justify-between pt-5 ">
        <div>
          <Button
            onClick={() => {
              handleReset()
            }}
          >
            Reset Filters
          </Button>
        </div>
        <div className="flex gap-2">
          <Button onClick={closePanel}>Cancel</Button>

          <Button
            type="submit"
            color="primary"
            onClick={() => {
              filterFormik.handleSubmit()
              closePanel()
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </>
  )
}

export default FilterPanel
